import PropTypes from 'prop-types';
import { useState } from 'react';

import Table from 'reactstrap/es/Table';
import Button from 'reactstrap/es/Button';
import Input from 'reactstrap/es/Input';
import SimplePagination from '@yooink/youi/dist/SimplePagination';
import { StatDisplay, YoApiComponentList } from '@yooink/yorestapi/frontend/es/YoApiComponent';
import { ConfirmModal } from 'reactstrap-alert/build/es';
import { FaSave, FaSpinner, FaTrash } from 'react-icons/fa';
import { useSetField } from '@yooink/youtils/es/hooks/useSetField';
import { EditorContext } from '@yooink/yocontextforms/es/SimpleEditorContext';
import { InputField } from '@yooink/yocontextforms/es/InputField';
import Col from 'reactstrap/es/Col';
import Row from 'reactstrap/es/Row';
import Api from './Api';

export class FiasToPostalCodeListAsEditableTable extends YoApiComponentList {
	getApi = () => Api;

	getBaseUrl = () => '/';

	create = async () => {
		await this.getApi().create({});
		await this.setState({ offset: 0 });
		await this.fetch();
	};

	render () {
		const { items } = this.state;
		return (
			<div>
				<div className="d_title">FiasToPostalCode</div>
				<div className="d_box">
					<Table>
						<thead>
							<tr>
								<th>_id</th>
								<th>
									<Input placeholder="fiasId" onChange={(e) => this.onChangeSearch('fiasId', e.target.value)} onBlur={this.fetch} />
								</th>
								<th>
									<Input placeholder="address" onChange={(e) => this.onChangeSearch('address', e.target.value)} onBlur={this.fetch} />
								</th>
								<th>
									<Input placeholder="postalCode" onChange={(e) => this.onChangeSearch('postalCode', e.target.value)} onBlur={this.fetch} />
								</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{items.map((item, index) => (
								<Item
									item={item}
									onRemoved={() => {
										const arr = items.slice();
										arr.splice(index, 1);
										this.setState({ items: arr });
									}}
									setLockTable={(lockState) => this.setState({ isLockedTable: lockState })}
								/>
							))}
						</tbody>
					</Table>
					<Row>
						<Col>
							<StatDisplay
								count={this.state.count}
								isLoading={this.state.isLoading}
								limit={this.state.limit}
								stat={this.state.stat}
								setLimit={(limit) => this.setState({ limit }, this.fetch)}
							/>
						</Col>
						<Col>
							{this.state.count > this.state.limit
								? (
									<SimplePagination
										offset={this.state.offset}
										limit={this.state.limit}
										count={this.state.count}
										showCount={10}
										setOffcet={(offset) => this.setState({ offset }, this.fetch)}
									/>
								) : null}
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

function Item ({ item: _item, onRemoved, setLockTable, isLockedTable }) {
	const [item, setField, trackedChanges, { reset }] = useSetField({ ..._item });
	const [disabled, setDisabled] = useState(false);
	async function remove () {
		if (await ConfirmModal('Вы действительно хотите удалить эту запись?')) {
			try {
				setDisabled(true);
				setLockTable(true);
				await Api.remove(item._id);
				onRemoved();
			} finally {
				setDisabled(false);
				setLockTable(false);
			}
		}
	}

	async function save () {
		try {
			setDisabled(true);
			await Api.edit(item._id, { _id: item._id, ...trackedChanges });
			reset();
		} finally {
			setDisabled(false);
		}
	}

	return (
		<EditorContext.Provider value={{
			item,
			setField
		}}
		>
			<tr>
				<th scope="row">{item._id.substr(-5)}</th>
				<td>
					{item.fiasId}
				</td>
				<td>
					{item.address}
				</td>
				<td>
					<InputField env={false} field="postalCode" />
				</td>
				<td>
					<Button color="danger" onClick={remove}>
						<FaTrash />
					</Button>
					<Button
						color="primary"
						disabled={disabled || Object.keys(trackedChanges).length === 0}
						onClick={save}
					>
						{disabled ? <FaSpinner /> : <FaSave />}
					</Button>
				</td>
			</tr>
		</EditorContext.Provider>

	);
}

Item.propTypes = {
  item: PropTypes.object.isRequired,
  isLockedTable: PropTypes.bool,
  onRemoved: PropTypes.func.isRequired,
  setLockTable: PropTypes.func.isRequired
};
